import React from "react";
import Strings from "../localization";
import { Link } from "react-router-dom";
import { bool } from "prop-types";

class Header extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedButton: this.props.page,
      headerStyle: "header-transparent",
    };
    this.handleScroll = this.handleScroll.bind(this);
  }

  setFilter(filter) {
    this.setState({ selectedButton: filter });
    var scrollToElement = document.getElementById(filter);
    if (
      scrollToElement &&
      (filter === "privacypolicy" || filter === "contact")
    ) {
      // scrollToElement.scrollIntoView()
      window.scrollTo({
        top: scrollToElement.offsetTop,
        behavior: "instant",
      });
    }
  }

  handleDropdownItemClick(e) {
    console.log("inside ");
    e.preventDefault();
    // this.showDropdown = true;
  }

  isActive(value) {
    return value === this.state.selectedButton ? "a" : "";
  }

  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.page) {
      this.setState({ selectedButton: nextProps.page });
    }
  }

  handleScroll(event) {
    let scrollTop = event.srcElement.body.scrollTop,
      itemTranslate = Math.min(0, scrollTop / 3 - 60);
    this.setState({
      headerStyle: "header",
    });
  }

  render() {
    return (
      <header
        className={
          "fixed clearfix navbar navbar-fixed-top " + this.state.headerStyle
        }
      >
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-3 col-md-3 col-lg-3 abcd">
              <div className="header-left clearfix">
                <div className="logo smooth-scroll">
                  {" "}
                  <a href="#banner">
                    {" "}
                    <img
                      id="logo"
                      src={"/images/nichesoft.png"}
                      alt="NicheSolv"
                    />{" "}
                  </a>{" "}
                </div>
                <div className="site-name-and-slogan smooth-scroll">
                  <div className="site-name">
                    {" "}
                    <a href="#banner"> NicheSolv </a>{" "}
                  </div>
                  <div className="site-slogan" id="slog">
                    Your Ideas, Our Code
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-9 col-lg-9">
              <div className="header-right clearfix">
                <div className="main-navigation animated">
                  <nav
                    className="navbar navbar-default navbar-fixed-top"
                    role="navigation"
                  >
                    <div className="container-fluid">
                      <div className="navbar-header">
                        <button
                          type="button"
                          className="navbar-toggle collapsed"
                          data-toggle="collapse"
                          data-target="#navbar-collapse-2"
                          aria-expanded="false"
                        >
                          <span className="sr-only">Toggle navigation</span>{" "}
                          <span className="icon-bar" />{" "}
                          <span className="icon-bar" />{" "}
                          <span className="icon-bar" />
                        </button>
                        <div className="header-left clearfix disp">
                          <div className="logo smooth-scroll">
                            {" "}
                            <a href="#banner">
                              {" "}
                              <img
                                id="logo1"
                                src={"/images/nichesoft.png"}
                                alt="NicheSolv"
                              />{" "}
                            </a>{" "}
                          </div>
                          <div className="site-name-and-slogan smooth-scroll">
                            <div className="site-name1">
                              {" "}
                              <a href="#banner"> NicheSolv </a>{" "}
                            </div>
                            <div className="site-slogan1" id="slog">
                              {" "}
                              Your Ideas, Our Code{" "}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className="collapse navbar-collapse scrollspy smooth-scroll"
                        id="navbar-collapse-2"
                      >
                        <ul className="nav navbar-nav navbar-right">
                          <li
                            id="hom"
                            className={this.isActive("home") + " hidden-xs"}
                          >
                            <Link to={"/#home"}>{Strings.home_label}</Link>
                          </li>

                          <li
                            className={this.isActive("services") + " hidden-xs"}
                          >
                            <Link
                              to={"/#services"}
                              onClick={this.props.trackScrolling}
                            >
                              {Strings.services_label}
                            </Link>
                          </li>

                          <li
                            id="proj"
                            className={this.isActive("projects") + " hidden-xs"}
                            onClick={() => this.setFilter("projects")}
                          >
                            <Link
                              id="navProjects"
                              to={"/#projects"}
                              onClick={this.props.trackScrolling}
                            >
                              {Strings.projects_label}
                            </Link>
                          </li>

                          <li
                            className={this.isActive("clients") + " hidden-xs"}
                            onClick={() => this.setFilter("clients")}
                          >
                            <Link
                              id="navClient"
                              to={"/#clients"}
                              onClick={this.props.trackScrolling}
                            >
                              {Strings.clients_label}
                            </Link>
                          </li>

                          <li
                            id="hom"
                            className={
                              this.isActive("home") +
                              " hidden-lg hidden-sm hidden-md"
                            }
                            data-toggle="collapse"
                            data-target="#navbar-collapse-2"
                          >
                            <Link to={"/#home"}>{Strings.home_label}</Link>
                          </li>

                          <li
                            className={
                              this.isActive("services") +
                              " hidden-lg hidden-sm hidden-md"
                            }
                            data-toggle="collapse"
                            data-target="#navbar-collapse-2"
                          >
                            <Link
                              to={"/#services"}
                              id="navServices"
                              onClick={this.props.trackScrolling}
                            >
                              {Strings.services_label}
                            </Link>
                          </li>

                          <li
                            id="proj"
                            className={
                              this.isActive("projects") +
                              " hidden-lg hidden-sm hidden-md"
                            }
                            onClick={() => this.setFilter("projects")}
                            data-toggle="collapse"
                            data-target="#navbar-collapse-2"
                          >
                            <Link
                              id="navProjects"
                              to={"/#projects"}
                              onClick={this.props.trackScrolling}
                            >
                              {Strings.projects_label}
                            </Link>
                          </li>

                          <li
                            className={
                              this.isActive("clients") +
                              " hidden-lg hidden-sm hidden-md"
                            }
                            onClick={() => this.setFilter("clients")}
                            data-toggle="collapse"
                            data-target="#navbar-collapse-2"
                          >
                            <Link
                              id="navClient"
                              to={"/#clients"}
                              onClick={this.props.trackScrolling}
                            >
                              {Strings.clients_label}
                            </Link>
                          </li>

                          <li className="hidden-xs" id="abt">
                            <a
                              href="#"
                              onClick={this.handleDropdownItemClick}
                              data-toggle="dropdown"
                            >
                              {Strings.careers_label}
                              <b className="caret" />
                            </a>

                            <ul className="dropdown-menu">
                              <li className={this.isActive("openPositions")}>
                                <Link to="/openPositions">
                                  {Strings.open_positions_label}
                                </Link>
                              </li>

                              <li className={this.isActive("work")}>
                                <Link
                                  to={"/#workhere"}
                                  onClick={this.props.trackScrolling}
                                >
                                  {Strings.work_culture_label}
                                </Link>
                              </li>

                              <li className={this.isActive("hiringProcess")}>
                                <Link to="/hiringProcess">
                                  {Strings.hiring_process_label}
                                </Link>
                              </li>

                              <li className={this.isActive("internWithUs")}>
                                <Link to="/internWithUs">
                                  {Strings.intern_with_us}
                                </Link>
                              </li>
                            </ul>
                          </li>

                          <li className="hidden-xs" id="abt">
                            <a href="#" data-toggle="dropdown">
                              {Strings.about_label}
                              <b className="caret" />
                            </a>
                            <ul className="dropdown-menu">
                              <li className={this.isActive("about")}>
                                <Link
                                  to={"/#about"}
                                  onClick={this.props.trackScrolling}
                                >
                                  {Strings.about_us_label}
                                </Link>
                              </li>

                              <li className={this.isActive("team")}>
                                <Link
                                  id="navTeam"
                                  to={"/#team"}
                                  onClick={this.props.trackScrolling}
                                >
                                  {Strings.team_label}
                                </Link>
                              </li>

                              <li className={this.isActive("social")}>
                                <Link
                                  id="navSocial"
                                  to={"/#social"}
                                  onClick={this.props.trackScrolling}
                                >
                                  {Strings.social_label}
                                </Link>
                              </li>

                              <li className={this.isActive("contact")}>
                                <Link
                                  to={"/#contact"}
                                  onClick={() => this.setFilter("contact")}
                                >
                                  {Strings.contact_label}
                                </Link>
                              </li>

                              <li className={this.isActive("privacypolicy")}>
                                <Link
                                  to={"/#privacypolicy"}
                                  onClick={() =>
                                    this.setFilter("privacypolicy")
                                  }
                                >
                                  {Strings.privacy_policy_label}
                                </Link>
                              </li>
                              <li className={this.isActive("rebrand")}>
                                <Link to="/rebrand">
                                  {Strings.rebrand_label}
                                </Link>
                              </li>
                            </ul>
                          </li>

                          <li
                            className={
                              "hidden-lg hidden-md hidden-sm " +
                              this.isActive("about")
                            }
                            data-toggle="collapse"
                            data-target="#navbar-collapse-2"
                          >
                            <Link
                              to={"/#about"}
                              id="navAbout"
                              onClick={this.props.trackScrolling}
                            >
                              {Strings.about_us_label}
                            </Link>
                          </li>

                          <li
                            className={
                              "hidden-lg hidden-md hidden-sm " +
                              this.isActive("openPositions")
                            }
                            data-toggle="collapse"
                            data-target="#navbar-collapse-2"
                          >
                            <Link to="/openPositions">
                              {Strings.open_positions_label}
                            </Link>
                          </li>

                          <li
                            className={
                              "hidden-lg hidden-md hidden-sm " +
                              this.isActive("work")
                            }
                            data-toggle="collapse"
                            data-target="#navbar-collapse-2"
                          >
                            <Link
                              to={"/#workhere"}
                              onClick={this.props.trackScrolling}
                            >
                              {Strings.work_culture_label}
                            </Link>
                          </li>

                          <li
                            className={
                              "hidden-lg hidden-md hidden-sm " +
                              this.isActive("hiringProcess")
                            }
                            data-toggle="collapse"
                            data-target="#navbar-collapse-2"
                          >
                            <Link
                              to="/hiringProcess"
                              onClick={this.props.trackScrolling}
                            >
                              {Strings.hiring_process_label}
                            </Link>
                          </li>

                          <li
                            className={
                              "hidden-lg hidden-md hidden-sm " +
                              this.isActive("internWithUs")
                            }
                            data-toggle="collapse"
                            data-target="#navbar-collapse-2"
                          >
                            <Link to="/internWithUs">
                              {Strings.intern_with_us}
                            </Link>
                          </li>

                          <li
                            className={
                              "hidden-lg hidden-md hidden-sm " +
                              this.isActive("team")
                            }
                            data-toggle="collapse"
                            data-target="#navbar-collapse-2"
                          >
                            <Link
                              id="navTeam"
                              to={"/#team"}
                              onClick={this.props.trackScrolling}
                            >
                              {Strings.team_label}
                            </Link>
                          </li>

                          <li
                            className={
                              "hidden-lg hidden-md hidden-sm " +
                              this.isActive("social")
                            }
                            data-toggle="collapse"
                            data-target="#navbar-collapse-2"
                          >
                            <Link
                              id="navSocial"
                              to={"/#social"}
                              onClick={this.props.trackScrolling}
                            >
                              {Strings.social_label}
                            </Link>
                          </li>

                          <li
                            className={
                              "hidden-lg hidden-md hidden-sm " +
                              this.isActive("contact")
                            }
                            data-toggle="collapse"
                            data-target="#navbar-collapse-2"
                          >
                            <Link
                              to={"/#contact"}
                              onClick={() => this.setFilter("contact")}
                            >
                              {Strings.contact_label}
                            </Link>
                          </li>

                          <li
                            style={{ backgroundColor: "b" }}
                            className={
                              "hidden-lg hidden-md hidden-sm " +
                              this.isActive("privacypolicy")
                            }
                            data-toggle="collapse"
                            data-target="#navbar-collapse-2"
                          >
                            <Link
                              to={"/#privacypolicy"}
                              onClick={() => this.setFilter("privacypolicy")}
                            >
                              {Strings.privacy_policy_label}
                            </Link>
                          </li>
                          <li
                            style={{ backgroundColor: "b" }}
                            className={
                              "hidden-lg hidden-md hidden-sm " +
                              this.isActive("rebrand")
                            }
                            data-toggle="collapse"
                            data-target="#navbar-collapse-2"
                          >
                            <Link to="/rebrand">{Strings.rebrand_label}</Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
    );
  }
}
export default Header;



// WEBPACK FOOTER //
// /home/reetika/Desktop/nichesolvweb/website/nswebsite/src/containers/header.js